export default __webpack_public_path__ + "static/media/2.27f1c698.png";